module.exports = __webpack_public_path__ + "static/img/major_pictgrid23_920x861.28cd02e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid23_920x861.jpg
// module id = FOot
// module chunks = 0